export default __webpack_public_path__ + "static/taj-mahal-74886b8895ca6c5d1dc6d6a0bd2b9e08.jpg";